import { useAuth } from "../contexts/AuthContext";

/**
 * Subscription gating — single source of truth for feature flags.
 */
export function useSubscription() {
  const { billing } = useAuth();
  const tier = billing?.tier || "free";
  const status = billing?.status || "free";
  const trialDaysRemaining = billing?.trial_days_remaining ?? null;
  const trackCount = billing?.track_count ?? 0;
  const trackLimit = billing?.track_limit ?? 25;
  const isPro = tier === "pro";
  const canAddTrack = isPro || trackCount < trackLimit;

  return {
    tier,
    status,
    trialDaysRemaining,
    trackCount,
    trackLimit,
    plan: billing?.plan,
    periodEnd: billing?.period_end,
    trialEndsAt: billing?.trial_ends_at,
    hasCard: !!billing?.has_card,
    canAddTrack,
    canImport: isPro,
    canBulkImport: isPro,
    canAutoVerify: isPro,
  };
}
